export default __webpack_public_path__ + "static/media/sbj-botany 1.cc03ba06.svg";